import { patchRequest } from '@/core';
import { subOrders } from '@/requests';

export default async function updateSubOrderRequest(id, data) {
	let url = subOrders.getByIdPath(id);
	let response = await patchRequest(url, {}, data);
	return response;
}
